import React from "react";
import { motion } from 'framer-motion';
import HeartImage1 from '../../assets/images/heart1.svg';
import HeartImage2 from '../../assets/images/heart2.svg'
import DonationButton from "./DonateButton";
import AnimatedNumber from '../layout/AnimateNumber';


export default function ImpactSection({ id }) {
    const titleClass = 'font-bold lg:text-5xl md:text-4xl text-2xl text-left text-md py-1 lg:my-3'
    const textClass = 'lg:text-2xl md:text-2xl text-xs'
    const textBold = 'font-bold'
    return (
        <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            viewport={{ once: true, amount: 0.3 }}
            id={id} className="bg-white flex flex-col items-center w-full mx-auto p-10 lg:py-0 scroll-mt-36 font-lato relative">
            <div className="text-left mt-24 lg:mt-0 md:mt-0">
                <img
                    src={HeartImage1}
                    alt="Nuestro trabajo"
                    className="w-1/12 absolute
                    top-[62px] right-[37px]
                    lg:top-[62px] lg:right-[167px]
                    md:top-[68px] md:right-[124px]"
                />
                <img
                    src={HeartImage2}
                    alt="Nuestro trabajo"
                    className="w-1/12 absolute
                    top-[104px] right-[33px]
                    lg:top-[181px] lg:right-[127px]
                    md:top-[143px] md:right-[103px]"
                />
                <p className={titleClass}>Todo donativo tiene su impacto</p>
                <p className="text-white text-2xl md:text-4xl lg:text-5xl mb-10"><span className="bg-idarkpink">Gracias a los donativos, en 2024...</span></p>
                <p className={textClass}>
                    Realizamos <span className={textBold}>6,357 pruebas de ITS</span>
                </p>
                <p className={textClass}>Aplicamos <span className={textBold}>195 vacunas</span></p>
                <p className={textClass}>Atendimos <span className={textBold}>186 consultas médicas</span></p>
                <p className={textClass}>Ofrecimos <span className={textBold}>253 consejerías</span></p>
                <p className={textClass}>Entregamos <span className={textBold}>23,162 insumos</span> para el cuidado de la salud sexual</p>
                <p className={textClass}>Realizamos <span className={textBold}>39 eventos para conectar</span> con nuestra comunidad</p>
                <p className={textClass}>Alcanzamos <span className={textBold}><AnimatedNumber to={1464995} /> personas</span> a través de redes sociales</p>
                <p className={`${textClass} mt-10`}>Todo esto gracias a las personas que creen y apoyan nuestro trabajo</p>
                <p className={textClass}><span className={textBold}>¡Gracias por hacer de Inspira Cambio A.C. una realidad!</span></p>
                <div className="flex justify-end">
                    <DonationButton></DonationButton>
                </div>
            </div>
        </motion.div>

    );
}

